"use strict";
exports.__esModule = true;
exports.DayEventsBlock = void 0;
var tslib_1 = require("tslib");
var utilities_1 = require("@sportnet/ui/lib/utilities");
var date_fns_1 = require("date-fns");
var sk_1 = tslib_1.__importDefault(require("date-fns/locale/sk"));
var polished_1 = require("polished");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var ProviderLogo_1 = tslib_1.__importDefault(require("./ProviderLogo"));
var TvProgramList_1 = tslib_1.__importDefault(require("./TvProgramList"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""])));
var LogoWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  margin-right: ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  margin-right: ", ";\n"])), function (_a) {
    var compact = _a.compact;
    return (compact ? 'none' : '1px solid #ddd');
}, function (_a) {
    var compact = _a.compact;
    return (compact ? 0 : polished_1.rem(8));
}, polished_1.rem(4), polished_1.rem(16));
var NotFoundWrapper = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  text-align: center;\n"], ["\n  font-size: ", ";\n  text-align: center;\n"])), polished_1.rem(15));
var HeaderWrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: start;\n  margin-top: ", ";\n"], ["\n  display: flex;\n  justify-content: start;\n  margin-top: ", ";\n"])), function (_a) {
    var compact = _a.compact;
    return (compact ? 0 : polished_1.rem(48));
});
var Header = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
var Title = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n"])), function (_a) {
    var compact = _a.compact;
    return (compact ? polished_1.rem(14) : polished_1.rem(24));
}, function (_a) {
    var compact = _a.compact;
    return (compact ? polished_1.rem(21) : polished_1.rem(29));
}, function (_a) {
    var theme = _a.theme;
    return theme.app.textColor;
}, function (_a) {
    var compact = _a.compact;
    return (compact ? polished_1.rem(8) : polished_1.rem(16));
}, function (_a) {
    var compact = _a.compact;
    return (compact ? 'bold' : '600');
}, function (_a) {
    var compact = _a.compact;
    return (compact ? 'none' : 'uppercase');
});
var Subtitle = styled_components_1["default"].div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n"])), function (_a) {
    var compact = _a.compact;
    return (compact ? polished_1.rem(14) : polished_1.rem(16));
}, function (_a) {
    var compact = _a.compact;
    return (compact ? polished_1.rem(21) : polished_1.rem(14));
}, function (_a) {
    var theme = _a.theme;
    return theme.app.textColor;
}, polished_1.rem(16), function (_a) {
    var compact = _a.compact;
    return (compact ? '400' : '600');
}, function (_a) {
    var compact = _a.compact;
    return (compact ? 'none' : 'uppercase');
});
var Separator = styled_components_1["default"].div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  border-bottom: 1px solid #ddd;\n  margin-bottom: ", ";\n"], ["\n  border-bottom: 1px solid #ddd;\n  margin-bottom: ", ";\n"])), function (_a) {
    var _b = _a.marginBottom, marginBottom = _b === void 0 ? polished_1.rem(32) : _b;
    return marginBottom;
});
exports.DayEventsBlock = function (_a) {
    var date = _a.date, events = _a.events, className = _a.className, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, lastRowUrl = _a.lastRowUrl, title = _a.title, subtitle = _a.subtitle, compact = _a.compact, handleLoadMore = _a.handleLoadMore, banner = _a.banner;
    var getDateStringEventList = function (date) {
        date = new Date(date);
        if (date_fns_1.isToday(date)) {
            return utilities_1.__('Dnes') + " " + date_fns_1.format(date, '(d.M.)');
        }
        else if (date_fns_1.isYesterday(date)) {
            return utilities_1.__('Včera') + " " + date_fns_1.format(date, '(d.M.)');
        }
        else if (date_fns_1.isTomorrow(date)) {
            return utilities_1.__('Zajtra') + " " + date_fns_1.format(date, '(d.M.)');
        }
        else {
            return date_fns_1.format(date, 'EEEE (d.M.)', {
                locale: sk_1["default"]
            });
        }
    };
    return (react_1["default"].createElement(Wrapper, { className: className },
        react_1["default"].createElement(HeaderWrapper, { compact: compact },
            compact && typeof subtitle !== 'string' && (subtitle === null || subtitle === void 0 ? void 0 : subtitle.logo) && (react_1["default"].createElement(LogoWrapper, { compact: true },
                react_1["default"].createElement(ProviderLogo_1["default"], { provider: subtitle, margin: '0' }))),
            react_1["default"].createElement(Header, null,
                react_1["default"].createElement(Title, { compact: compact }, title === 'generated' ? getDateStringEventList(date) : title),
                !compact && react_1["default"].createElement(Separator, null),
                subtitle && (react_1["default"].createElement(Subtitle, { compact: compact }, typeof subtitle === 'string' ? (subtitle) : (react_1["default"].createElement(react_1["default"].Fragment, null,
                    !compact && subtitle.logo && (react_1["default"].createElement(LogoWrapper, null,
                        react_1["default"].createElement(ProviderLogo_1["default"], { provider: subtitle, margin: '0', size: 32 }))),
                    subtitle.name)))))),
        compact && react_1["default"].createElement(Separator, { marginBottom: polished_1.rem(12) }),
        events.length > 0 ? (react_1["default"].createElement(TvProgramList_1["default"], { events: events, compact: compact, isLogoInSubtitle: !!subtitle && Object.keys(subtitle).includes('logo'), lastRowUrl: lastRowUrl, handleLoadMore: handleLoadMore, isLoading: isLoading, banner: banner })) : (react_1["default"].createElement(NotFoundWrapper, null, utilities_1.__('Pre zvolené kritériá, alebo časové obdobie, neboli nájdené žiadne športové prenosy.')))));
};
exports["default"] = exports.DayEventsBlock;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
